/**
 * Central Management > 객체 >
 * DLP >> DLP 예외 프로파일 store
 *
 * @since 2020-04-10
 * @author tams_dev2
 */

export const state = () => ({
  finalCommand: '/api/op/dlp/exceptions',
  api: {
    url: '/api/op/dlp/exceptions',
    config: {
      loading: false,
      successAlert: false
    }
  },
  // Profile
  dlpExpProfileList: [],
  editDlpExpProfileData: [],
  // Object
  dlpExpObjectList: [],
  editDlpExpObjectData: [],
  objectList: []
})

export const mutations = {
  setObjectList: (state, data) => {
    state.objectList = data
  },
  setDlpExpProfileData: (state, data) => {
    state.dlpExpProfileList = data
  },
  addDlpExpProfileData: (state, data) => {
    state.dlpExpProfileList.push(data)
  },
  editDlpExpProfileList: (state, data) => {
    state.dlpExpProfileList = _.map(state.dlpExpProfileList, (o) => {
      if (o.dlp_excpt_prf_id === data.dlp_excpt_prf_id) {
        o = data
      }
      return o
    })
  },
  setDlpExpObjectData: (state, data) => {
    state.dlpExpObjectList = data
  },
  addDlpExpObjectData: (state, data) => {
    state.dlpExpObjectList.push(data)
  },
  editDlpExpObjectList: (state, data) => {
    state.dlpExpObjectList = _.map(state.dlpExpObjectList, (o) => {
      if (o.dlp_excpt_id === data.dlp_excpt_id) {
        o = data
      }
      return o
    })
  }
}

export const actions = {
  async setObjectList ({commit, state}, data) {
    commit('setObjectList', data)
  },
  // DLP 예외 프로파일 단일/다중 조회
  async getDlpExpProfileData ({commit, state}, profId = null) {
    const
      isMulti = _.isNil(profId),
      url = `${state.api.url}${(isMulti) ? '' : `/${profId}`}`

    try {
      const {code, result} = await this.$axios.$get(url, state.api.config)
      if (code === 'ok' && isMulti) {
        commit('setDlpExpProfileData', result)
      }
      return {code, result}
    } catch (e) {
      this.$log('getDlpExpProfileList Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 프로파일 삭제
  async delDlpExpProfileData ({commit, state}, [item, profId = null]) {
    const apiUrl = `${state.api.url}`
    let param = []

    if (_.size(item.items) > 1) {
      param = [
        apiUrl,
        _.assignIn({ data: item }, _.cloneDeep(state.api.config))
      ]
    } else {
      param = [
        `${apiUrl}/${profId}`,
        _.cloneDeep(state.api.config)
      ]
    }

    try {
      const {code, result} = await this.$axios.$delete(...param)
      return {code, result}
    } catch (e) {
      this.$log('delDlpExpProfileData Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 프로파일 추가/수정
  async setDlpExpProfile ({commit, state}, [items, profId = null]) {
    const
      isAdd = _.isNil(profId),
      method = (isAdd) ? '$post' : '$put',
      url = `${state.api.url}${(isAdd) ? '' : `/${profId}`}`

    try {
      const {code, result} = await this.$axios[method](
        url,
        items,
        state.api.config
      )

      if (code === 'ok') {
        if (isAdd) {
          commit('addDlpExpProfileData', result)
        } else {
          commit('editDlpExpProfileList', result)
        }
        // this.dispatch(`common/common/setIsChanged`, true)
      }
      return {code, result}
    } catch (e) {
      this.$log('setDlpExpProfile Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 프로파일 사용 수정/일괄수정
  async markedUseDlpExpProfile ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$put(state.api.url, {items: state.editDlpExpProfileData}, {failAlert: false})
      return {code, result}
    } catch (e) {
      this.$log('markedUseDlpExpProfile Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 객체 단일/다중 조회
  async getDlpExpObjectData ({commit, state}, [profId, excpId = null]) {
    const
      isMulti = _.isNil(excpId),
      url = `${state.api.url}/${profId}/objects${(isMulti) ? '' : `/${excpId}`}`

    try {
      const {code, result} = await this.$axios.$get(url)
      if (code === 'ok' && isMulti) {
        commit('setDlpExpObjectData', result)
      }
      return {code, result}
    } catch (e) {
      this.$log('dlpExpObjectList Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 객체 삭제
  async delDlpExpObjectData ({commit, state}, [item, profId, excpId = null]) {
    const apiUrl = `${state.api.url}/${profId}/objects`
    let param = []

    if (_.size(item.items) > 1) {
      param = [
        apiUrl,
        _.assignIn({ data: item }, _.cloneDeep(state.api.config))
      ]
    } else {
      param = [
        `${apiUrl}/${excpId}`,
        _.cloneDeep(state.api.config)
      ]
    }

    try {
      const {code, result} = await this.$axios.$delete(
        ...param,
        state.api.config
      )
      return {code, result}
    } catch (e) {
      this.$log('delDlpExpObjectData Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 프로파일 - 멤버 - 추가/수정
  // DLP 예외 객체 추가/수정
  async setDlpExpObject ({commit, state}, [item, profId, excpId = null]) {
    const
      isAdd = _.isNil(excpId),
      method = (isAdd) ? '$post' : '$put',
      url = `${state.api.url}/${profId}/objects${(isAdd) ? '' : `/${excpId}`}`

    try {
      const
        param = _.assignIn({ dlp_excpt_prf_id: profId }, (isAdd) ? {} : { dlp_excpt_id: excpId }, item),
        {code, result} = await this.$axios[method](
          url,
          param,
          state.api.config
        )

      if (code === 'ok') {
        if (isAdd) {
          commit('addDlpExpObjectData', result)
        } else {
          commit('editDlpExpObjectList', result)
        }
        // this.dispatch(`common/common/setIsChanged`, true)
      }
      return {code, result}
    } catch (e) {
      this.$log('setDlpExpObject Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP 예외 객체 사용 수정/일괄수정
  async markedUseDlpExpObject ({commit, state}, profId) {
    try {
      const {code, result} = await this.$axios.$put(`${state.api.url}/${profId}/objects`, {items: state.editDlpExpObjectData}, {failAlert: false})
      return {code, result}
    } catch (e) {
      this.$log('markedUseDlpExpObject Exception -> ', e)
      return {code: 'nok', result: {msg: e}}
    }
  },
  // DLP EXP 적용/취소
  async finalCommand ({commit, state}, {type, loadingShow = true}) {
    try {
      const param = _.assign({ loadingShow: loadingShow }, (_.eq(type, 'apply')) ? { applyMsg: true } : { cancelMsg: true })
      const {code} = await this.$axios.$put(`${state.finalCommand}/${type}`, null, param)
      if (code === 'ok') {
        return true
      }
    } catch (e) {
      this.$log('[DLP EXP] finalCommand Exception -> ', e)
    }
    return false
  }
}
